import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingDatesForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

import css from './EditListingDatesPanel.module.css';
import { postAdminListingPublic } from '../../util/api';
import BackToAdmin from '../BackToAdminButton/BackToAdminButton';

const { Money } = sdkTypes;

const EditListingDatesPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { price} = currentListing.attributes;
  const { inputDate, activeDate, leaseSignDate, leaseStartDate, leaseEndDate } = currentListing.attributes.publicData;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingDatesPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingDatesPanel.createListingTitle" />
  );

  const initialValues = { price};

  if (inputDate) {
    initialValues.inputDate = { date: new Date(inputDate) };
  }
  if (activeDate) {
    initialValues.activeDate = { date: new Date(activeDate) };
  }
  if (leaseSignDate) {
    initialValues.leaseSignDate = { date: new Date(leaseSignDate) };
  }
  if (leaseStartDate) {
    initialValues.leaseStartDate = { date: new Date(leaseStartDate) };
  }
  if (leaseEndDate) {
    initialValues.leaseEndDate = { date: new Date(leaseEndDate) };
  }

  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = priceCurrencyValid ? (
    <EditListingDatesForm
      className={css.form}
      initialValues={{ price, ...initialValues}}
      onSubmit={async values => {
        const { price, inputDate, activeDate, leaseSignDate, leaseStartDate, leaseEndDate } = values;
        const publicData = { };

  
       if (inputDate) {
          publicData.inputDate = inputDate?.date?.toDateString();
        }
       if (activeDate) {
          publicData.activeDate = activeDate?.date?.toDateString();
        }
        if (leaseSignDate) {
          publicData.leaseSignDate = leaseSignDate?.date?.toDateString();
        }
        if (leaseStartDate) {
          publicData.leaseStartDate = leaseStartDate?.date?.toDateString();
        }
        if (leaseEndDate) {
          publicData.leaseEndDate = leaseEndDate?.date?.toDateString();
        }

    

        const payload = {
          id: listing.id.uuid,
          publicData
        };
        await postAdminListingPublic(payload)
        await onSubmit({price});
        // this.forceUpdate();
      }}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
    />
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingDatesPanel.listingPriceCurrencyInvalid" />
    </div>
  );

  return (
    <div className={classes}>
      <BackToAdmin />
      <h1 className={css.title}>{panelTitle}</h1>
      {form}
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingDatesPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingDatesPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingDatesPanel;
